import { useMutation } from '@tanstack/react-query';
import { ascvdApi } from 'modules/report/services/ascvd-calculator-service';

export const useAscvd = () => {
  return useMutation({
    mutationFn: ascvdApi,
    onError: (error) => {
      console.log(error);
    }
  });
};
